import { debounce } from 'lodash';
import React, {
  ChangeEvent,
  FocusEvent,
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../../../../app/dialog/dialog.actions';
import { saveScoreboard } from '../../../../../../../../../app/page/page-storage/kpi/kpi.actions';
import { kpiRowScoreboardSelectors } from '../../../../../../../../../app/resource/kpi-row-scoreboard/kpi-row-scoreboard.selectors';
import { scoreSelectors } from '../../../../../../../../../app/resource/score/score.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { IKpiRowScoreboardProps } from './types';

export const KpiRowScoreboard: FunctionComponent<IKpiRowScoreboardProps> = ({
  scoreId,
  kpiRowScoreboardId,
  rowIndex,
}) => {
  const dispatch = useDispatch();
  const scoreboard = useSelectWithParams(kpiRowScoreboardSelectors.selectResourceById, kpiRowScoreboardId);
  const score = useSelectWithParams(scoreSelectors.selectResourceById, scoreId);
  const [measure, setMeasure] = useState('');
  const scoreType = score ? score.type : '';
  useEffect(() => {
    if (scoreboard) {
      if (scoreboard.measured === '' || scoreboard.measured === null) {
        setMeasure('');
      } else {
        if (`${scoreboard.measured}` !== `${Math.ceil(Number(scoreboard.measured))}.00`) {
          const number = scoreboard.measured.split('.');
          let value = Number(number[0]).toLocaleString();
          if (number[1]) {
            value = value.concat('.', number[1].substring(0, 2));
          }
          setMeasure(value);
        } else {
          setMeasure(`${Math.ceil(Number(scoreboard.measured)).toLocaleString()}`);
        }
      }
    }
    //setMeasure(scoreboard ? `${Math.ceil(Number(scoreboard.measured))}` : '');
  }, [scoreType, scoreboard]);

  const inputClass = useMemo(() => {
    const green = 'lightGreen-bg green';
    const red = 'lightRed-bg red';
    const gray = '';
    // if (scoreboard) {
    //   return gray;
    // }
    if (!score) {
      return gray;
    }
    if (scoreboard && scoreboard.measured !== null && scoreboard.measured.toString() !== '') {
      if (score.goal === '>=') {
        return Number(measure.replaceAll(',', '')) >= +score.score ? green : red;
      } else if (score.goal === '<=') {
        return Number(measure.replaceAll(',', '')) <= +score.score ? green : red;
      } else if (score.goal === '==') {
        return Number(measure.replaceAll('.', '')) === +score.score ? green : red;
      }
    } else {
      return gray;
    }

    return red;
  }, [measure, score, scoreboard]);

  const scoreboardRef = useRef(scoreboard);
  scoreboardRef.current = scoreboard;

  const debouncedSaveScoreboard = useMemo(
    () =>
      debounce((measured: string) => {
        const sb = scoreboardRef.current;
        if (!sb || sb.measured === measured) {
          return;
        }
        if (measured.startsWith('.')) {
          measured = `0${measured}`;
        }
        dispatch(saveScoreboard({ ...sb, measured: measured.replaceAll(',', '') }));
      }, 5000),
    [dispatch],
  );

  useEffect(() => () => debouncedSaveScoreboard.cancel(), [debouncedSaveScoreboard]);

  const saveScoreboardMeasure = (measured: string) => {
    if (scoreboard && scoreboard.measured !== measured) {
      if (measured.startsWith('.')) {
        measured = `0${measured}`;
      }
      dispatch(saveScoreboard({ ...scoreboard, measured: measured.replaceAll(',', '') }));
    }
  };

  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    debouncedSaveScoreboard.cancel();
    const newMeasure = event.target.value;
    saveScoreboardMeasure(newMeasure);
  };

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const measured = event.target.value;
      setMeasure(measured);
      //setMeasure(`${Math.ceil(measured)}`);
      debouncedSaveScoreboard(measured);
    },
    [debouncedSaveScoreboard],
  );

  const openKpiNoteFormDialog = useCallback(() => {
    dispatch(openDialog('kpiNoteFormDialog', { scoreboard }));
  }, [dispatch, scoreboard]);

  return (
    scoreboard && (
      <div className="kpi-date kpi-input" style={{ width: '148px', maxWidth: '148px' }}>
        {score?.type === 'dollar' && scoreboard.measured ? (
          <span className={inputClass} style={{ position: 'absolute', left: '22px', top: '8px' }}>
            $
          </span>
        ) : score?.type === 'percentage' && scoreboard.measured ? (
          <span className={inputClass} style={{ position: 'absolute', left: '22px', top: '8px' }}>
            %
          </span>
        ) : (
          <></>
        )}
        <input
          tabIndex={rowIndex}
          type="text"
          className={inputClass}
          style={{ width: '120px' }}
          value={measure}
          onChange={onChange}
          onBlur={onBlur}
        />
        {inputClass === 'lightRed-bg red' || inputClass === 'lightGreen-bg green' ? (
          <span
            className={`white-bg ${
              scoreboard.note ? 'lightGreen-border' : 'lightRed-border'
            } round-icon-smaller popup_button`}
            data-popup="new_note_popup"
            onClick={openKpiNoteFormDialog}
            style={{ zIndex: 0 }}
          >
            <i className="icon-pencil" />
          </span>
        ) : (
          <></>
        )}
      </div>
    )
  );
};
